// services/representativeService.js

import { axiosInstance } from './api';

export const representativeService = {
    // Get all representatives with pagination and filtering
    // ✅ FIXED: Now calls /users/representatives endpoint
    getAllRepresentatives: async (params = {}) => {
        const response = await axiosInstance.get('/users/representatives', { params });
        return response.data;
    },

    // Get representative by ID
    getRepresentativeById: async (id) => {
        const response = await axiosInstance.get(`/users/${id}`);
        return response.data;
    },

    // Create new representative
    createRepresentative: async (data) => {
        const response = await axiosInstance.post('/users', {
            ...data,
            userType: 'representative'
        });
        return response.data;
    },

    // Update representative
    updateRepresentative: async (id, data) => {
        const response = await axiosInstance.patch(`/users/${id}`, data);
        return response.data;
    },

    // Delete representative
    deleteRepresentative: async (id) => {
        const response = await axiosInstance.delete(`/users/${id}`);
        return response.data;
    },

    // Get top representatives
    // ✅ FIXED: Now calls /users/representatives endpoint
    getTopRepresentatives: async (limit = 10) => {
        const response = await axiosInstance.get('/users/representatives', {
            params: {
                limit,
                sortBy: 'patientsCount',
                sortOrder: 'desc'
            }
        });
        return response.data;
    },

    // Get representative statistics
    // ✅ FIXED: Now calls /users/representatives/:id/stats endpoint
    getRepresentativeStats: async (id, params = {}) => {
        const response = await axiosInstance.get(`/users/representatives/${id}/stats`, { params });
        return response.data;
    },

    // Recalculate representative counts
    recalculateCounts: async (id) => {
        const response = await axiosInstance.post(`/users/${id}/recalculate`);
        return response.data;
    },

    // Get representatives for dropdown (active only)
    // ✅ FIXED: Now calls /users/representatives/dropdown endpoint
    getRepresentativesForDropdown: async () => {
        const response = await axiosInstance.get('/users/representatives/dropdown');
        return response.data;
    },

    // Search representatives
    // ✅ FIXED: Now calls /users/representatives endpoint
    searchRepresentatives: async (searchTerm) => {
        const response = await axiosInstance.get('/users/representatives', {
            params: {
                search: searchTerm,
                isActive: true
            }
        });
        return response.data;
    },

    // Get representative by ID number
    // ✅ FIXED: Now calls /users/representatives endpoint
    getByIdNumber: async (idNumber) => {
        const response = await axiosInstance.get('/users/representatives', {
            params: {
                representativeIdNumber: idNumber
            }
        });
        return response.data;
    },

    // Toggle representative active status
    toggleActiveStatus: async (id, isActive) => {
        const response = await axiosInstance.patch(`/users/${id}`, { isActive });
        return response.data;
    },

    // Update representative password
    updatePassword: async (id, newPassword) => {
        const response = await axiosInstance.patch(`/users/${id}/password`, {
            password: newPassword
        });
        return response.data;
    }
};

export default representativeService;